import {Adsense} from '@ctrl/react-adsense';

const Credit = (width, height, format, cssClasses) => {
   

  return (
        <div className={"white_box credits " }> 
             
          אייקונים נעשו ע"י משה צישינסקי, גלי זורע 
         \ עיצוב: גלי זורע 
        </div>
       
    );
}

export default Credit; 